import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {Store, Student} from 'src/types/store';
import {getAcademicInterestList} from 'src/redux/lists';
import ActionMenuButton from 'shared/components/action-menu-button';
import ActionButton from 'shared/components/action-menu-button/action-button';
import PdfLink from 'shared/components/action-menu-button/pdf-link';
import TextButton from 'src/components/TextButton';

interface Props {
  student: Student;
  onClick: () => void;
}

const Bio = ({
  student: {academicInterestIds, bio, currentInstitution, firstName, lastName, highSchoolInfo},
  onClick,
  student,
}: Props) => {
  const dispatch = useDispatch();
  const academicInterests = useSelector((state: Store) => state.lists.academicInterests);
  const academicInterestsMap = useMemo(
    () =>
      academicInterests.reduce((accumulator, interest) => {
        accumulator[interest._id] = interest.name;

        return accumulator;
      }, {}),
    [academicInterests]
  );

  useEffect(() => {
    dispatch(getAcademicInterestList());
  }, [dispatch]);

  const interests = academicInterestIds.map((id) => academicInterestsMap[id]);

  return (
    <div className="about-me-info">
      <ActionMenuButton>
        <ActionButton onClick={onClick}>Edit</ActionButton>
        {student && (
          <PdfLink
            filename="raise_me_resume.pdf"
            printInfo={{student}}
            eventName="print-resume-high-school"
          >
            Print Resume
          </PdfLink>
        )}
      </ActionMenuButton>
      <h1 className="about-me-info-name">
        {firstName} {lastName}
      </h1>
      <h2 className="about-me-info-grad-year">
        {highSchoolInfo.graduationYear ? `Class of ${highSchoolInfo.graduationYear}` : ''}
      </h2>
      <h3 className="about-me-info-school">{currentInstitution.name}</h3>
      {bio ? (
        <p className="about-me-info-bio">{bio}</p>
      ) : (
        <div>
          <TextButton className="about-me-info-placeholder" onClick={onClick}>
            + Add a brief description about yourself
          </TextButton>
        </div>
      )}
      {interests.length > 0 ? (
        <p className="about-me-info-bio">
          <span className="about-me-info-interest">Interests:</span> {interests.join(', ')}
        </p>
      ) : (
        <div>
          <TextButton className="about-me-info-placeholder" onClick={onClick}>
            + Add what you&#39;re interested in studying
          </TextButton>
        </div>
      )}
    </div>
  );
};

export default Bio;
